(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-image"] && !Shopify.designMode) return;
  try {
    // Handle lazy loading with fade-in effect
  document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll('.responsive-image img[loading="lazy"]');
    
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          
          // If image is already loaded, show it immediately
          if (img.complete) {
            img.classList.add('loaded');
          } else {
            // Otherwise wait for load event
            img.addEventListener('load', function() {
              img.classList.add('loaded');
            });
            
            // Fallback: if load event doesn't fire, show after a delay
            setTimeout(() => {
              if (!img.classList.contains('loaded')) {
                img.classList.add('loaded');
              }
            }, 1000);
          }
          
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-height-calculator"] && !Shopify.designMode) return;
  try {
    (function() {
    var CACHE_PREFIX = 'headerHeight_v2_';
    var RESIZE_DEBOUNCE_MS = 100;

    function cacheKey() {
      return CACHE_PREFIX + window.innerWidth + 'x' + window.innerHeight;
    }

    function getTransparentSections() {
      return document.querySelectorAll('.section-transparent');
    }

    function measureHeight() {
      var siteHeader = document.querySelector('.site-header');
      var height = siteHeader ? siteHeader.offsetHeight : 0;
      var expandTransparent = document.querySelector('header[data-expand-header="true"][data-transparency="true"]');
      if (expandTransparent) {
        var toolbar = document.querySelector('.toolbar-section');
        if (toolbar) height += toolbar.offsetHeight;
      }
      return height;
    }

    function applyOffset(heightValue, showSections) {
      document.documentElement.style.setProperty('--margin-top-header', heightValue);
      var pxMatch = /^-(\d+)px$/.exec(heightValue);
      document.documentElement.style.setProperty('--header-height', (pxMatch ? pxMatch[1] : '0') + 'px');
      if (showSections) {
        getTransparentSections().forEach(function(section) {
          section.classList.add('header-offset-ready');
        });
      }
    }

    function recalculate(saveToCache, showSections) {
      var h = measureHeight();
      if (!h) {
        document.documentElement.style.setProperty('--header-height', '0px');
        return;
      }
      var heightValue = '-' + h + 'px';
      applyOffset(heightValue, showSections);
      if (saveToCache !== false) {
        try { sessionStorage.setItem(cacheKey(), heightValue); } catch (e) {}
      }
    }

    function onResize() {
      recalculate(true, false);
    }

    document.addEventListener('DOMContentLoaded', function() {
      var key = cacheKey();
      var transparentSections = getTransparentSections();
      var cached;
      try { cached = sessionStorage.getItem(key); } catch (e) {}

      if (cached) {
        applyOffset(cached, true);
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { recalculate(true, false); });
        });
      } else {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { recalculate(true, true); });
        });
      }

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(onResize, RESIZE_DEBOUNCE_MS);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
